import React from 'react';
import PropTypes from 'prop-types';

const TimelineView = ({ data }) => {
  const eyebrow = data?.eyebrow || '';
  const title = data?.title || '';
  const variant = data?.variant || 'default';
  const items = Array.isArray(data?.items) ? data.items : [];

  const cls = ['ag-timeline', `ag-timeline--${variant}`].join(' ');

  return (
    <section className={cls}>
      <div className="ag-timeline__container">
        {(eyebrow || title) && (
          <header className="ag-timeline__header">
            {eyebrow && <div className="ag-timeline__eyebrow">{eyebrow}</div>}
            {title && <h2 className="ag-timeline__title">{title}</h2>}
          </header>
        )}
        {items.length > 0 && (
          <ol className="ag-timeline__list">
            {items.map((it, idx) => {
              const date = it?.date || '';
              const itemTitle = it?.title || '';
              const desc = it?.desc || '';
              return (
                <li className="ag-timeline__item" key={`tl-${idx}`}>
                  {date && <div className="ag-timeline__date">{date}</div>}
                  {itemTitle && (
                    <div className="ag-timeline__itemtitle">{itemTitle}</div>
                  )}
                  {desc && <p className="ag-timeline__desc">{desc}</p>}
                </li>
              );
            })}
          </ol>
        )}
      </div>
    </section>
  );
};

TimelineView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};

export default TimelineView;
